import { createRoot } from 'react-dom/client';
import App from './App';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import * as Sentry from '@sentry/react';
import { captureGoogleAdsAttribution } from './~reusables/util/googleAdsAttribution';
import { installChunkLoadRecovery } from './~reusables/util/chunkLoadRecovery';
import {
  sentryDenyUrls,
  sentryIgnoreErrors,
  shouldDropSentryEvent,
  shouldReportToSentry,
} from './~reusables/util/sentryFilters';

captureGoogleAdsAttribution();
installChunkLoadRecovery();

if (shouldReportToSentry()) {
  Sentry.init({
    dsn: 'https://f4a9b899abae4b56bfbe452b937d43bf@sentry.io/1438425',
    ignoreErrors: sentryIgnoreErrors,
    denyUrls: sentryDenyUrls,
    beforeSend: (event, hint) =>
      shouldDropSentryEvent(event, hint) ? null : event,
  });
}

const cache = createCache({ key: 'css' });

const AppWithErrorBoundary = Sentry.withErrorBoundary(App, {
  fallback: ({ error }) => (
    <div>An error occurred: {(error as Error).message}</div>
  ),
});

const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(
  <CacheProvider value={cache}>
    <AppWithErrorBoundary />
  </CacheProvider>,
);
